module.exports = __webpack_public_path__ + "static/media/sort-shapes-up-alt.49ec9a68.svg";